module.exports = __webpack_public_path__ + "static/media/github-cli-screenshot.343fea07.png";